<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title
        >字典数据维护
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="表格列设置"
            icon="e6-icon-field_line"
            @click="columSetVisible = !columSetVisible"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            title="删除"
            icon="e6-icon-clear_line"
            @click="handleBatchDeleteUser"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            icon="e6-icon-add_line"
            @click="$router.push('/systemSettingDataDictionaryMaintenanceEdit')"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.dicName">
            <el-input
              v-model="slotForms.forms.dicName"
              placeholder="字典名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="forms.dicTypeKey">
            <el-select
              v-model="slotForms.forms.dicTypeKey"
              clearable
              filterable
              placeholder="请选择字典类型"
            >
              <el-option
                v-for="item in dicTypeKeyList"
                :key="item.dicTypeKey"
                :label="item.dicTypeName"
                :value="item.dicTypeKey"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          align="center"
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column
          v-for="(item, index) in localShowTableCols"
          :key="index"
          :show-overflow-tooltip="true"
          :prop="item.name"
          :label="item.title"
        ></el-table-column>
        <el-table-column align="center" label="操作" width="80">
          <template slot-scope="scope">
            <router-link
              :to="{
                path: '/systemSettingDataDictionaryMaintenanceEdit',
                query: { pageType: '2', id: scope.row.id }
              }"
              >编辑
            </router-link>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 批量删除确认 -->
    <e6-message-box
      :messageBoxVisible.sync="messageBoxVisible"
      @messageBoxSubmit="handleMessageBoxSubmit"
    >
      <div class="batch-delete">确认删除字典数据？</div>
    </e6-message-box>
    <!-- 批量删除确认 end -->
    <!-- 表格列设置 -->
    <e6-column-set
      @setColumnSubmit="handleSetColumnSubmit"
      @setColumnCancel="handleSetColumnCancel"
      :columSetVisible.sync="columSetVisible"
      :hideTableCols.sync="copyHideTableCols"
      :showTableCols.sync="copyShowTableCols"
    ></e6-column-set>
    <!-- 表格列设置 end -->
  </div>
</template>

<script>
import {
  FetchGetTableColumnSettings,
  FetchSaveUserTableColumnSettings
} from "_private/api/public.js";
import {
  FetchFindByPage,
  FetchDelete,
  FetchDictionaryType
} from "@/api/systemSetting/dataDictionaryMaintenance";
import { mapGetters, mapActions } from "vuex";
import resizeListener from "_private/mixins/resizeListener";
import { mergeFormExtend } from "_private/utils/merge";

export default {
  mixins: [resizeListener],
  data() {
    return {
      total: 0,
      curPage: 1,
      pageSize: 10,
      isSearch: false,
      formExtend: {
        forms: {
          dicName: "",
          dicTypeKey: ""
        },
        extends: []
      },
      dicTypeKeyList: [],
      formsExtend: [],
      tableData: [],
      columSetVisible: false,
      showTableCols: [],
      hideTableCols: [],
      copyShowTableCols: [],
      copyHideTableCols: [],
      localShowTableCols: [],
      multipleSelection: [],
      messageBoxVisible: false,
      analysisError: false,
      aErrorDatas: [],
      errMess: "",
      loading: "false"
    };
  },
  computed: {
    ...mapGetters(["moduleId", "searchFormIsOpen", "userId"]),
    ids() {
      let ids = this.multipleSelection.map(item => {
        return item.id;
      });
      return ids.length < 1 ? "" : ids.join(",");
    },
    columnStr() {
      let columnStr = this.copyShowTableCols.map(item => {
        return item.name;
      });
      return columnStr.length < 1 ? "" : columnStr.join(",");
    }
  },
  created() {
    this.FetchFindByPage(this.mergeObj());
    this.FetchGetTableColumnSettings({
      moduleId: this.moduleId,
      userId: this.userId
    });
    this.FetchDictionaryType();
    this.setSearchFormIsOpenAct();
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),

    // 获取字典下拉框
    FetchDictionaryType() {
      FetchDictionaryType()
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            this.dicTypeKeyList = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取表格数据
    FetchFindByPage(response) {
      this.loading = true;
      FetchFindByPage(response)
        .then(response => {
          if (
            response.result &&
            response.result.data &&
            Array.isArray(response.result.data)
          ) {
            this.tableData = response.result.data;
            this.total = response.result.totalRecords;
          }
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
    // 获取表格列列表
    FetchGetTableColumnSettings(data) {
      FetchGetTableColumnSettings(data)
        .then(response => {
          let data = response;
          let showTableCols = [];
          let hideTableCols = [];
          if (data && data.result && Array.isArray(data.result)) {
            data.result.forEach(item => {
              if (item.show) {
                showTableCols.push(item);
              } else {
                hideTableCols.push(item);
              }
            });
          }
          this.showTableCols = showTableCols;
          this.hideTableCols = hideTableCols;
          this.copyShowTableCols = showTableCols;
          this.copyHideTableCols = hideTableCols;
          this.localShowTableCols = showTableCols;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 修改表格列列表
    FetchSaveUserTableColumnSettings(data) {
      FetchSaveUserTableColumnSettings(data)
        .then(response => {
          let type = response.code === 1 ? "success" : "error";
          let message = response.message;
          this.$message({
            showClose: true,
            message: message,
            type: type,
            duration: 2000,
            onClose: () => {
              if (type === "success") {
                this.FetchGetTableColumnSettings({
                  moduleId: this.moduleId,
                  userId: this.userId
                });
              }
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 删除字典数据
    FetchDelete(data) {
      FetchDelete(data)
        .then(response => {
          let type = response.code === 1 ? "success" : "error";
          let message = response.message;
          this.$message({
            showClose: true,
            message: message,
            type: type,
            duration: 2000,
            onClose: () => {
              if (type === "success") {
                this.curPage = 1;
                this.FetchFindByPage(this.mergeObj());
              }
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        curPage: this.curPage,
        pageSize: this.pageSize
      });
    },
    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },
    // 查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.FetchFindByPage(this.mergeObj());
    },
    // 选择表格列
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.FetchFindByPage(this.mergeObj());
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.FetchFindByPage(this.mergeObj());
    },
    // 打开确认删除面板
    handleBatchDeleteUser() {
      if (this.ids === "") {
        return this.$message({
          showClose: true,
          message: "请最少选择一条数据！",
          type: "error",
          duration: 1200
        });
      }
      this.messageBoxVisible = true;
    },
    // 确认删除
    handleMessageBoxSubmit() {
      this.FetchDelete({ ids: this.ids });
    },
    // 取消表格列设置
    handleSetColumnCancel() {
      this.copyShowTableCols = this.showTableCols;
      this.copyHideTableCols = this.hideTableCols;
    },
    // 确认表格列设置
    handleSetColumnSubmit() {
      this.FetchSaveUserTableColumnSettings({
        moduleId: this.moduleId,
        userId: this.userId,
        columnStr: this.columnStr
      });
    },
    ExportClick() {
      let param = "ruleType=1";
      if (
        this.formExtend.forms.wareHouseName !== null &&
        this.formExtend.forms.wareHouseName !== ""
      ) {
        param += "&wareHouseName=" + this.formExtend.forms.wareHouseName;
      }
      if (
        this.formExtend.forms.storeName !== null &&
        this.formExtend.forms.storeName !== ""
      ) {
        param += "&storeName=" + this.formExtend.forms.storeName;
      }
      if (
        this.formExtend.forms.createTimeList !== null &&
        this.formExtend.forms.createTimeList.length > 0
      ) {
        param += "&createTimeList=" + this.formExtend.forms.createTimeList;
      }
      if (
        this.formExtend.forms.carrierId !== null &&
        this.formExtend.forms.carrierId !== ""
      ) {
        param += "&carrierId=" + this.formExtend.forms.carrierId;
      }
      document.location.href = this.exportUrl + param;
    },
    // 删除导入文件名
    deleteFileName() {
      this.fileName = "";
    },
    // 改变导入文件
    onChange(file) {
      this.fileName = file.name;
    },
    // 导入接口调用成功
    onSuccess(response) {
      if (response.isSuccess) {
        // 导入成功
        this.aErrorDatas = [];
        this.analysisError = false;
        this.errMess = "";
        this.fileName = "";
        this.importFile = false;
        let message = response.msg;
        let type = "success";
        this.$message({
          showClose: true,
          message: message,
          type: type,
          duration: 2000,
          onClose: () => {
            if (type === "success") {
              this.FetchFindByPage(this.mergeObj());
            }
          }
        });
      } else {
        // 导入失败
        if (response.isSuccess === false) {
          let errObj = response.data;
          this.errMess = response.msg;
          for (let i in errObj) {
            if (errObj[i] !== "") {
              this.aErrorDatas.push(errObj[i]);
            }
          }
        } else {
          this.aErrorDatas.push(response.msg);
        }
        this.analysisError = true;
      }
    },
    // 关闭导入弹窗
    importDialogClose() {
      this.aErrorDatas = [];
      this.analysisError = false;
      this.errMess = "";
      this.fileName = "";
      this.importFile = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}
</style>
